import {LastCallValueObjectFactory} from '../ValueObjects/factory.js'
import {FromRawParamToCreateLastCallRequestValueObjectMapper} from './FromRawParamToCreateLastCallRequestValueObjectMapper.js'

export class LastCallMappersFactory {
  static fromRawParamToCreateLastCallRequestValueObjectMapper = ({config}) =>
    new FromRawParamToCreateLastCallRequestValueObjectMapper({
      config,
      createLastCallRequestValueObjectFactory: LastCallValueObjectFactory.createLastCallRequestValueObject
    })
}
